/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitLineupConfigurationChangesInput = {|
  greenMachineSessionId: string,
  configuration: ConfigurationInput,
  clientMutationId?: ?string,
|};
export type ConfigurationInput = {|
  numLineups: number,
  maxSalary: number,
  minSalary: number,
|};
export type CommitLineupConfigurationMutationVariables = {|
  input: CommitLineupConfigurationChangesInput
|};
export type CommitLineupConfigurationMutationResponse = {|
  +commitLineupConfigurationChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitLineupConfigurationMutation = {|
  variables: CommitLineupConfigurationMutationVariables,
  response: CommitLineupConfigurationMutationResponse,
|};
*/


/*
mutation CommitLineupConfigurationMutation(
  $input: CommitLineupConfigurationChangesInput!
) {
  commitLineupConfigurationChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitLineupConfigurationChangesPayload",
    "kind": "LinkedField",
    "name": "commitLineupConfigurationChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitLineupConfigurationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitLineupConfigurationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "382fcbee53b6830fa509243c411c472d",
    "id": null,
    "metadata": {},
    "name": "CommitLineupConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation CommitLineupConfigurationMutation(\n  $input: CommitLineupConfigurationChangesInput!\n) {\n  commitLineupConfigurationChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '939e3044c251e7398b6500d784edc4ad';

module.exports = node;
